import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IPage, IPageSize, ISearchValue, ISort, TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

const initialState: TDefaultStoreDTO = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
};

const moBranches = createSlice({
	name: 'moBranches',
	initialState,
	reducers: {
		setPage: (state, action: PayloadAction<IPage>) => {
			state.page = action.payload.page;
		},
		setPageSize: (state, action: PayloadAction<IPageSize>) => {
			state.pageSize = action.payload.pageSize;
			state.page = initialState.page;
		},
		setSort: (state, action: PayloadAction<ISort>) => {
			state.sortDirection = action.payload.sortDirection;
			state.sortFieldName = action.payload.sortFieldName;
		},
		setSearchValue: (state, action: PayloadAction<ISearchValue>) => {
			state.searchValue = action.payload.searchValue;
			state.page = initialState.page;
		},
		resetMoBranchesTable: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	resetMoBranchesTable,
} = moBranches.actions;

export default moBranches.reducer;
